/**
 * @generated SignedSource<<4945250e2907a99b0f43f4d67c988227>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProjectFinancialsPage_Query$variables = {
  projectId?: string | null;
  currentYear?: number | null;
  currentMonth?: number | null;
  currentMonthLastDay?: number | null;
};
export type ProjectFinancialsPage_Query$data = {
  readonly viewer: {
    readonly actualPersonId: string | null;
    readonly project: {
      readonly id: string;
    } | null;
    readonly component: string | null;
    readonly " $fragmentSpreads": FragmentRefs<"ProjectFinancialsPage_viewer">;
  } | null;
};
export type ProjectFinancialsPage_Query = {
  variables: ProjectFinancialsPage_Query$variables;
  response: ProjectFinancialsPage_Query$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "currentMonth"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "currentMonthLastDay"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "currentYear"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectId"
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actualPersonId",
  "storageKey": null
},
v5 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "projectId"
  }
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v7 = [
  (v6/*: any*/)
],
v8 = {
  "kind": "Variable",
  "name": "projectId",
  "variableName": "projectId"
},
v9 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "name",
      "value": "project_budget_v3"
    },
    (v8/*: any*/)
  ],
  "kind": "ScalarField",
  "name": "component",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v11 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 10000
  }
],
v12 = [
  (v6/*: any*/),
  (v10/*: any*/)
],
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "billable",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "price",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cost",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "invoiced",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullName",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "profilePictureId",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "profilePictureDefaultId",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actualCost",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actualRevenue",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currency",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "defaultRate",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "parentRateCardId",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rate",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startDate",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "concreteType": "Role",
  "kind": "LinkedField",
  "name": "role",
  "plural": false,
  "selections": (v12/*: any*/),
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": (v11/*: any*/),
  "concreteType": "RateTypeConnection",
  "kind": "LinkedField",
  "name": "rates",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "RateTypeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Rate",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v6/*: any*/),
            (v28/*: any*/),
            (v26/*: any*/),
            (v29/*: any*/),
            (v30/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "rates(first:10000)"
},
v32 = {
  "kind": "Literal",
  "name": "convertToProjectCurrency",
  "value": true
},
v33 = [
  (v32/*: any*/)
],
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "billableActualMinutes",
  "storageKey": null
},
v35 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 100000
  }
],
v36 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1000
  }
],
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "disabled",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ProjectFinancialsPage_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          {
            "alias": null,
            "args": (v5/*: any*/),
            "concreteType": "ProjectType",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": (v7/*: any*/),
            "storageKey": null
          },
          (v9/*: any*/),
          {
            "args": [
              {
                "kind": "Variable",
                "name": "currentMonth",
                "variableName": "currentMonth"
              },
              {
                "kind": "Variable",
                "name": "currentMonthLastDay",
                "variableName": "currentMonthLastDay"
              },
              {
                "kind": "Variable",
                "name": "currentYear",
                "variableName": "currentYear"
              },
              (v8/*: any*/)
            ],
            "kind": "FragmentSpread",
            "name": "ProjectFinancialsPage_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "ProjectFinancialsPage_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          {
            "alias": null,
            "args": (v5/*: any*/),
            "concreteType": "ProjectType",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              (v10/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "budgetType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "useBaseline",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectEndYear",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectEndMonth",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectEndDay",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "companyProjectId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "customProjectId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasInvoices",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "SageProjectType",
                "kind": "LinkedField",
                "name": "sageProject",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "sageProjectId",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v11/*: any*/),
                "concreteType": "ExpenseItemTypeConnection",
                "kind": "LinkedField",
                "name": "expenseItems",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ExpenseItemTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ExpenseItem",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ExpenseCategory",
                            "kind": "LinkedField",
                            "name": "category",
                            "plural": false,
                            "selections": (v12/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "PhaseType",
                            "kind": "LinkedField",
                            "name": "phase",
                            "plural": false,
                            "selections": (v12/*: any*/),
                            "storageKey": null
                          },
                          (v10/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "approved",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "expenseYear",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "expenseMonth",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "expenseDay",
                            "storageKey": null
                          },
                          (v13/*: any*/),
                          (v14/*: any*/),
                          (v15/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "quantity",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "planned",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "createdAt",
                            "storageKey": null
                          },
                          (v16/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Person",
                            "kind": "LinkedField",
                            "name": "person",
                            "plural": false,
                            "selections": [
                              (v6/*: any*/),
                              (v17/*: any*/),
                              (v18/*: any*/),
                              (v19/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v20/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "partOfFixedPrice",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "periodLocked",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v21/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v22/*: any*/)
                ],
                "storageKey": "expenseItems(first:10000)"
              },
              {
                "alias": null,
                "args": (v11/*: any*/),
                "filters": null,
                "handle": "connection",
                "key": "Project_expenseItems",
                "kind": "LinkedHandle",
                "name": "expenseItems"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "FinancialSourceSettings",
                "kind": "LinkedField",
                "name": "financialSourceSettings",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "plannedCost",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "plannedRevenue",
                    "storageKey": null
                  },
                  (v23/*: any*/),
                  (v24/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "forecastCost",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "forecastRevenue",
                    "storageKey": null
                  },
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "plannedHours",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "forecastHours",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "actualHours",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "financialDataAvailability",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectFirstDateYear",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectFirstDateMonth",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectFirstDateDay",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectLastDateYear",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectLastDateMonth",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectLastDateDay",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "budget",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "defaultPeriodBudgetType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RateCard",
                "kind": "LinkedField",
                "name": "rateCard",
                "plural": false,
                "selections": [
                  (v25/*: any*/),
                  (v6/*: any*/),
                  (v10/*: any*/),
                  (v26/*: any*/),
                  (v27/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Role",
                    "kind": "LinkedField",
                    "name": "disabledRoles",
                    "plural": true,
                    "selections": (v7/*: any*/),
                    "storageKey": null
                  },
                  (v31/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "estimationUnit",
                "storageKey": null
              },
              (v13/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "manualProgressOnProjectEnabled",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "manualProgressOnPhasesEnabled",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "manualProgressOnTasksEnabled",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "timeRegBasedPlusDoneScopeCompletion",
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v33/*: any*/),
                "concreteType": "FinancialNumbers",
                "kind": "LinkedField",
                "name": "financialNumbers",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "baselineRevenue",
                    "storageKey": null
                  },
                  (v24/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "baselineProfit",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "actualProfit",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "totalRevenueProfitAtCompletion",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "baselineMargin",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "actualMargin",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "totalRevenueMarginAtCompletion",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "billableActualTimeAndExpenses",
                    "storageKey": null
                  },
                  (v23/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "billableForecastTimeAndExpensesToComplete",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "forecastCostToComplete",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "totalCostAtCompletion",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "billableTotalTimeAndExpensesAtCompletion",
                    "storageKey": null
                  },
                  (v16/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "paid",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "recognitionProfit",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "recognitionProfitPercentage",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "totalRevenueRecognition",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "projectTotalForecastTimeAndExpensesToCompleteInPast",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "baselineCost",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "baselineVsForecastCost",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "allActualTimeAndExpenses",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "allForecastTimeAndExpensesToComplete",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "allTotalTimeAndExpensesAtCompletion",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "baselineTimeAndExpenses",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "baselineVsBillableTotalTimeAndExpensesAtCompletion",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "estimatedCost",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "planVsTotalCostAtCompletion",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "billablePlannedTimeAndExpenses",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "registeredMinutes",
                    "storageKey": null
                  },
                  (v34/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "nonBillableActualMinutes",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "forecastMinutes",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "baselineMinutes",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "scopeApprovedMinutes",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "projectedTotalMinutes",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "projectedBillableMinutes",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "projectedNonBillableMinutes",
                    "storageKey": null
                  }
                ],
                "storageKey": "financialNumbers(convertToProjectCurrency:true)"
              },
              {
                "alias": "financialNumbersToCurrentMonth",
                "args": [
                  (v32/*: any*/),
                  {
                    "kind": "Variable",
                    "name": "endDay",
                    "variableName": "currentMonthLastDay"
                  },
                  {
                    "kind": "Variable",
                    "name": "endMonth",
                    "variableName": "currentMonth"
                  },
                  {
                    "kind": "Variable",
                    "name": "endYear",
                    "variableName": "currentYear"
                  }
                ],
                "concreteType": "FinancialNumbers",
                "kind": "LinkedField",
                "name": "financialNumbers",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "recognitionLockedProfit",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "recognitionLockedProfitPercentage",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "recognitionLockedRevenue",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v35/*: any*/),
                "concreteType": "RetainerPeriodTypeConnection",
                "kind": "LinkedField",
                "name": "retainerPeriods",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RetainerPeriodTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "RetainerPeriodType",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "endYear",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "endMonth",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "endDay",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": (v33/*: any*/),
                            "concreteType": "FinancialNumbers",
                            "kind": "LinkedField",
                            "name": "financialNumbers",
                            "plural": false,
                            "selections": [
                              (v34/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "retainerPeriodTargetPrice",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "retainerPeriodRolloverPrice",
                                "storageKey": null
                              },
                              (v23/*: any*/)
                            ],
                            "storageKey": "financialNumbers(convertToProjectCurrency:true)"
                          },
                          (v6/*: any*/),
                          (v20/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v21/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v22/*: any*/)
                ],
                "storageKey": "retainerPeriods(first:100000)"
              },
              {
                "alias": null,
                "args": (v35/*: any*/),
                "filters": [],
                "handle": "connection",
                "key": "HighLevelBudgetNumbers_retainerPeriods",
                "kind": "LinkedHandle",
                "name": "retainerPeriods"
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "useFixedPriceForBaselineRevenue",
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v36/*: any*/),
                "concreteType": "ProjectFixedPriceLockTypeConnection",
                "kind": "LinkedField",
                "name": "fixedPriceLocks",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProjectFixedPriceLockTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ProjectFixedPriceLockType",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/),
                          (v29/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "endDate",
                            "storageKey": null
                          },
                          (v20/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "locked",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v21/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v22/*: any*/)
                ],
                "storageKey": "fixedPriceLocks(first:1000)"
              },
              {
                "alias": null,
                "args": (v36/*: any*/),
                "filters": [],
                "handle": "connection",
                "key": "Project_fixedPriceLocks",
                "kind": "LinkedHandle",
                "name": "fixedPriceLocks"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "stage",
                "plural": false,
                "selections": [
                  (v20/*: any*/),
                  (v6/*: any*/),
                  (v10/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "profile",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "taskCostCalculationType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "unassignedTaskHourlyCost",
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v36/*: any*/),
                "concreteType": "ProjectPersonTypeConnection",
                "kind": "LinkedField",
                "name": "projectPersons",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProjectPersonTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ProjectPerson",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Person",
                            "kind": "LinkedField",
                            "name": "person",
                            "plural": false,
                            "selections": [
                              (v6/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isViewer",
                                "storageKey": null
                              },
                              (v17/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "initials",
                                "storageKey": null
                              },
                              (v18/*: any*/),
                              (v19/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "active",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "permissions",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": (v11/*: any*/),
                                "concreteType": "CostPeriodTypeConnection",
                                "kind": "LinkedField",
                                "name": "costPeriods",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "CostPeriodTypeEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "CostPeriod",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          (v6/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "startDay",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "startMonth",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "startYear",
                                            "storageKey": null
                                          },
                                          (v15/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": "costPeriods(first:10000)"
                              }
                            ],
                            "storageKey": null
                          },
                          (v30/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "projectPersons(first:1000)"
              },
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 100000000
                  }
                ],
                "concreteType": "InvoiceTypeConnection",
                "kind": "LinkedField",
                "name": "invoices",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "InvoiceTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "InvoiceType",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "status",
                            "storageKey": null
                          },
                          (v6/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "invoices(first:100000000)"
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "flatRate",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "flatCost",
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v36/*: any*/),
                "concreteType": "DeliverableTypeConnection",
                "kind": "LinkedField",
                "name": "deliverables",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "DeliverableTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "DeliverableType",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/),
                          (v10/*: any*/),
                          (v14/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "deliverables(first:1000)"
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectRevRecFirstDateYear",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectRevRecFirstDateMonth",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectRevRecFirstDateDay",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectRevRecLastDateYear",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectRevRecLastDateMonth",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectRevRecLastDateDay",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "budgetWork",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "plannedBillableExpenses",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectColor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isInProjectGroup",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectGroupCompanyId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectGroupName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectGroupColor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sprintTimeBox",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectGroupId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "baselineRouteAccess",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v9/*: any*/),
          (v6/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "email",
            "storageKey": null
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "companyProjectId",
                "variableName": "projectId"
              }
            ],
            "concreteType": "ProjectServiceProjectType",
            "kind": "LinkedField",
            "name": "psProject",
            "plural": false,
            "selections": [
              (v10/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ProgramType",
                "kind": "LinkedField",
                "name": "psProgram",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  (v10/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "color",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "prefix",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isViewerProgramMember",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v6/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "tier",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sageIntacctConnectionEnabled",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sageIntacctTimeRegsFromForecast",
                "storageKey": null
              },
              (v25/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isUsingProjectAllocation",
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v11/*: any*/),
                "concreteType": "ExpenseCategoryTypeConnection",
                "kind": "LinkedField",
                "name": "expenseCategories",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ExpenseCategoryTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ExpenseCategory",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/),
                          (v10/*: any*/),
                          (v37/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "expenseCategories(first:10000)"
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "newXeroEnabled",
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v11/*: any*/),
                "concreteType": "RoleTypeConnection",
                "kind": "LinkedField",
                "name": "roles",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RoleTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Role",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": (v12/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "roles(first:10000)"
              },
              {
                "alias": null,
                "args": (v11/*: any*/),
                "concreteType": "ExchangeRateTypeConnection",
                "kind": "LinkedField",
                "name": "dateEffectiveExchangeRates",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ExchangeRateTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ExchangeRate",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/),
                          (v25/*: any*/),
                          (v28/*: any*/),
                          (v29/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "dateEffectiveExchangeRates(first:10000)"
              },
              {
                "alias": null,
                "args": (v11/*: any*/),
                "concreteType": "RateCardTypeConnection",
                "kind": "LinkedField",
                "name": "rateCards",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RateCardTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "RateCard",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/),
                          (v10/*: any*/),
                          (v25/*: any*/),
                          (v27/*: any*/),
                          (v37/*: any*/),
                          (v26/*: any*/),
                          (v31/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "rateCards(first:10000)"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Module",
                "kind": "LinkedField",
                "name": "modules",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "moduleType",
                    "storageKey": null
                  },
                  (v6/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "3eb6d4216ac475cd45efa2bfa9a4c399",
    "id": null,
    "metadata": {},
    "name": "ProjectFinancialsPage_Query",
    "operationKind": "query",
    "text": "query ProjectFinancialsPage_Query(\n  $projectId: String\n  $currentYear: Int\n  $currentMonth: Int\n  $currentMonthLastDay: Int\n) {\n  viewer {\n    actualPersonId\n    project(id: $projectId) {\n      id\n    }\n    component(name: \"project_budget_v3\", projectId: $projectId)\n    ...ProjectFinancialsPage_viewer_90Dg7\n    id\n  }\n}\n\nfragment ActualDetailsTable_project on ProjectType {\n  fixedPriceLocks(first: 1000) {\n    edges {\n      node {\n        id\n        startDate\n        endDate\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  ...DetailsTable_project\n}\n\nfragment BudgetData_company on Company {\n  tier\n  ...HighLevelBudgetNumbers_company\n}\n\nfragment BudgetData_project_3GwKxC on ProjectType {\n  ...Chart_project\n  ...HighLevelBudgetNumbers_project_3GwKxC\n  ...Totals_project\n  ...InvoiceChart_project\n  id\n  billable\n}\n\nfragment BudgetPageHeader_company on Company {\n  id\n  tier\n  sageIntacctConnectionEnabled\n  sageIntacctTimeRegsFromForecast\n  currency\n}\n\nfragment BudgetPageHeader_project on ProjectType {\n  id\n  projectFirstDateYear\n  projectFirstDateMonth\n  projectFirstDateDay\n  projectLastDateYear\n  projectLastDateMonth\n  projectLastDateDay\n  budgetType\n  budget\n  defaultPeriodBudgetType\n  rateCard {\n    currency\n    id\n  }\n  estimationUnit\n  billable\n  manualProgressOnProjectEnabled\n  manualProgressOnPhasesEnabled\n  manualProgressOnTasksEnabled\n}\n\nfragment BudgetPage_company on Company {\n  tier\n  ...BudgetPageHeader_company\n  ...BudgetData_company\n  ...Details_company\n}\n\nfragment BudgetPage_project_3GwKxC on ProjectType {\n  id\n  financialDataAvailability\n  ...BudgetPageHeader_project\n  ...BudgetData_project_3GwKxC\n  ...TimeBudgetData_project\n  ...Details_project\n  ...InvoiceDetails_project\n  ...TimeDetails_project\n  ...ExpenseDetails_project\n  manualProgressOnProjectEnabled\n  manualProgressOnPhasesEnabled\n  manualProgressOnTasksEnabled\n  budgetType\n}\n\nfragment Chart_project on ProjectType {\n  id\n  projectFirstDateYear\n  projectFirstDateMonth\n  projectFirstDateDay\n  projectLastDateYear\n  projectLastDateMonth\n  projectLastDateDay\n}\n\nfragment DetailsTable_project on ProjectType {\n  id\n  projectFirstDateYear\n  projectFirstDateMonth\n  projectFirstDateDay\n  projectLastDateYear\n  projectLastDateMonth\n  projectLastDateDay\n}\n\nfragment Details_company on Company {\n  id\n  isUsingProjectAllocation\n}\n\nfragment Details_project on ProjectType {\n  id\n  useBaseline\n  budgetType\n  defaultPeriodBudgetType\n  projectFirstDateYear\n  projectFirstDateMonth\n  projectFirstDateDay\n  projectLastDateYear\n  projectLastDateMonth\n  projectLastDateDay\n  estimationUnit\n  billable\n  ...DetailsTable_project\n  ...ActualDetailsTable_project\n  financialSourceSettings {\n    plannedHours\n    plannedRevenue\n    plannedCost\n    forecastHours\n    forecastRevenue\n    forecastCost\n    actualHours\n    actualRevenue\n    actualCost\n    id\n  }\n}\n\nfragment ExpenseDetailsTable_project on ProjectType {\n  id\n  projectFirstDateYear\n  projectFirstDateMonth\n  projectFirstDateDay\n  projectLastDateYear\n  projectLastDateMonth\n  projectLastDateDay\n}\n\nfragment ExpenseDetails_project on ProjectType {\n  id\n  useBaseline\n  budgetType\n  defaultPeriodBudgetType\n  projectFirstDateYear\n  projectFirstDateMonth\n  projectFirstDateDay\n  projectLastDateYear\n  projectLastDateMonth\n  projectLastDateDay\n  billable\n  financialSourceSettings {\n    plannedHours\n    plannedRevenue\n    plannedCost\n    forecastHours\n    forecastRevenue\n    forecastCost\n    actualHours\n    actualRevenue\n    actualCost\n    id\n  }\n  ...ExpenseDetailsTable_project\n}\n\nfragment ExpenseRevenueRecognition_project on ProjectType {\n  id\n  billable\n  plannedBillableExpenses\n  projectRevRecFirstDateYear\n  projectRevRecFirstDateMonth\n  projectRevRecFirstDateDay\n  projectRevRecLastDateYear\n  projectRevRecLastDateMonth\n  projectRevRecLastDateDay\n  fixedPriceLocks(first: 1000) {\n    edges {\n      node {\n        id\n        startDate\n        endDate\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment HighLevelBudgetNumbers_company on Company {\n  tier\n  id\n  currency\n}\n\nfragment HighLevelBudgetNumbers_project_3GwKxC on ProjectType {\n  id\n  useBaseline\n  hasInvoices\n  budget\n  budgetType\n  defaultPeriodBudgetType\n  timeRegBasedPlusDoneScopeCompletion\n  rateCard {\n    currency\n    id\n  }\n  financialNumbers(convertToProjectCurrency: true) {\n    baselineRevenue\n    actualRevenue\n    baselineProfit\n    actualProfit\n    totalRevenueProfitAtCompletion\n    baselineMargin\n    actualMargin\n    totalRevenueMarginAtCompletion\n    billableActualTimeAndExpenses\n    actualCost\n    billableForecastTimeAndExpensesToComplete\n    forecastCostToComplete\n    totalCostAtCompletion\n    billableTotalTimeAndExpensesAtCompletion\n    invoiced\n    paid\n    recognitionProfit\n    recognitionProfitPercentage\n    totalRevenueRecognition\n    projectTotalForecastTimeAndExpensesToCompleteInPast\n    baselineCost\n    baselineVsForecastCost\n    allActualTimeAndExpenses\n    allForecastTimeAndExpensesToComplete\n    allTotalTimeAndExpensesAtCompletion\n    baselineTimeAndExpenses\n    baselineVsBillableTotalTimeAndExpensesAtCompletion\n    estimatedCost\n    planVsTotalCostAtCompletion\n    billablePlannedTimeAndExpenses\n  }\n  financialNumbersToCurrentMonth: financialNumbers(endYear: $currentYear, endMonth: $currentMonth, endDay: $currentMonthLastDay, convertToProjectCurrency: true) {\n    recognitionLockedProfit\n    recognitionLockedProfitPercentage\n    recognitionLockedRevenue\n  }\n  expenseItems(first: 10000) {\n    edges {\n      node {\n        approved\n        billable\n        partOfFixedPrice\n        expenseYear\n        expenseMonth\n        expenseDay\n        price\n        cost\n        quantity\n        id\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  retainerPeriods(first: 100000) {\n    edges {\n      node {\n        endYear\n        endMonth\n        endDay\n        financialNumbers(convertToProjectCurrency: true) {\n          billableActualMinutes\n          retainerPeriodTargetPrice\n          retainerPeriodRolloverPrice\n          actualCost\n        }\n        id\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment HighLevelTimeNumbers_project on ProjectType {\n  id\n  useBaseline\n  billable\n  financialNumbers(convertToProjectCurrency: true) {\n    registeredMinutes\n    billableActualMinutes\n    nonBillableActualMinutes\n    forecastMinutes\n    baselineMinutes\n    scopeApprovedMinutes\n    projectedTotalMinutes\n    projectedBillableMinutes\n    projectedNonBillableMinutes\n  }\n}\n\nfragment InvoiceChart_project on ProjectType {\n  id\n  projectFirstDateYear\n  projectFirstDateMonth\n  projectFirstDateDay\n  projectLastDateYear\n  projectLastDateMonth\n  projectLastDateDay\n}\n\nfragment InvoiceDetailsTable_project on ProjectType {\n  id\n  projectFirstDateYear\n  projectFirstDateMonth\n  projectFirstDateDay\n  projectLastDateYear\n  projectLastDateMonth\n  projectLastDateDay\n}\n\nfragment InvoiceDetails_project on ProjectType {\n  ...InvoiceDetailsTable_project\n  budgetType\n}\n\nfragment ProjectFinancialsPage_viewer_90Dg7 on Viewer {\n  id\n  actualPersonId\n  email\n  project(id: $projectId) {\n    id\n    name\n    budgetType\n    useBaseline\n    projectEndYear\n    projectEndMonth\n    projectEndDay\n    companyProjectId\n    customProjectId\n    hasInvoices\n    sageProject {\n      id\n      sageProjectId\n    }\n    expenseItems(first: 10000) {\n      edges {\n        node {\n          id\n          category {\n            id\n            name\n          }\n          phase {\n            id\n            name\n          }\n          name\n          approved\n          expenseYear\n          expenseMonth\n          expenseDay\n          billable\n          price\n          cost\n          quantity\n          planned\n          createdAt\n          invoiced\n          person {\n            id\n            fullName\n            profilePictureId\n            profilePictureDefaultId\n          }\n          __typename\n        }\n        cursor\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n    financialSourceSettings {\n      plannedCost\n      plannedRevenue\n      actualCost\n      actualRevenue\n      forecastCost\n      forecastRevenue\n      id\n    }\n    ...BudgetPage_project_3GwKxC\n    ...expensesPage_project\n    ...ratesAndInternalCostPage_project\n    ...RatesAndInternalCostLitePage_project\n    ...RevenueRecognitionPage_project\n    ...ProjectHeader_project\n    ...SecondaryNavigation_project\n  }\n  psProject(companyProjectId: $projectId) {\n    ...ProjectHeader_psProject\n    id\n  }\n  company {\n    id\n    tier\n    ...BudgetPage_company\n    ...expensesPage_company\n    ...ratesAndInternalCostPage_company\n    ...RatesAndInternalCostLitePage_company\n    ...RevenueRecognitionPage_company\n    modules {\n      moduleType\n      id\n    }\n    sageIntacctConnectionEnabled\n  }\n}\n\nfragment ProjectHeader_project on ProjectType {\n  id\n  companyProjectId\n  ...ProjectIndicatorJS_project\n  name\n  projectColor\n  isInProjectGroup\n  projectGroupCompanyId\n  projectGroupName\n  projectGroupColor\n  useBaseline\n  budgetType\n  sprintTimeBox\n}\n\nfragment ProjectHeader_psProject on ProjectServiceProjectType {\n  name\n  psProgram {\n    id\n    name\n    color\n    prefix\n    isViewerProgramMember\n  }\n}\n\nfragment ProjectIndicatorJS_project on ProjectType {\n  name\n  companyProjectId\n  customProjectId\n  projectColor\n}\n\nfragment RateCardDropdown_rateCards on RateCardTypeEdge {\n  node {\n    id\n    name\n    currency\n    parentRateCardId\n    disabled\n  }\n}\n\nfragment RatesAndInternalCostLitePage_company on Company {\n  id\n  currency\n}\n\nfragment RatesAndInternalCostLitePage_project on ProjectType {\n  id\n  budgetType\n  flatRate\n  flatCost\n}\n\nfragment RevenueRecognitionPage_company on Company {\n  id\n  currency\n}\n\nfragment RevenueRecognitionPage_project on ProjectType {\n  id\n  rateCard {\n    id\n    currency\n  }\n  budgetType\n  ...RevenueRecognition_project\n  ...TimeRevenueRecognition_project\n  ...ExpenseRevenueRecognition_project\n}\n\nfragment RevenueRecognition_project on ProjectType {\n  id\n  budgetType\n  deliverables(first: 1000) {\n    edges {\n      node {\n        id\n        name\n        price\n      }\n    }\n  }\n  billable\n  defaultPeriodBudgetType\n  projectFirstDateYear\n  projectFirstDateMonth\n  projectFirstDateDay\n  projectLastDateYear\n  projectLastDateMonth\n  projectLastDateDay\n  projectRevRecFirstDateYear\n  projectRevRecFirstDateMonth\n  projectRevRecFirstDateDay\n  projectRevRecLastDateYear\n  projectRevRecLastDateMonth\n  projectRevRecLastDateDay\n  estimationUnit\n  fixedPriceLocks(first: 1000) {\n    edges {\n      node {\n        id\n        locked\n        startDate\n        endDate\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  rateCard {\n    currency\n    id\n  }\n}\n\nfragment SecondaryNavigation_project on ProjectType {\n  companyProjectId\n  customProjectId\n  sprintTimeBox\n  budgetType\n  projectGroupId\n  useBaseline\n  baselineRouteAccess\n  hasInvoices\n  financialSourceSettings {\n    plannedCost\n    plannedRevenue\n    actualCost\n    actualRevenue\n    forecastCost\n    forecastRevenue\n    id\n  }\n}\n\nfragment TimeBudgetData_project on ProjectType {\n  ...TimeChart_project\n  ...TimeTotals_project\n  ...HighLevelTimeNumbers_project\n}\n\nfragment TimeChart_project on ProjectType {\n  id\n  projectFirstDateYear\n  projectFirstDateMonth\n  projectFirstDateDay\n  projectLastDateYear\n  projectLastDateMonth\n  projectLastDateDay\n}\n\nfragment TimeDetails_project on ProjectType {\n  id\n  projectFirstDateYear\n  projectFirstDateMonth\n  projectFirstDateDay\n  projectLastDateYear\n  projectLastDateMonth\n  projectLastDateDay\n  ...DetailsTable_project\n  financialSourceSettings {\n    plannedHours\n    plannedRevenue\n    plannedCost\n    forecastHours\n    forecastRevenue\n    forecastCost\n    actualHours\n    actualRevenue\n    actualCost\n    id\n  }\n}\n\nfragment TimeRevenueRecognition_project on ProjectType {\n  id\n  billable\n  budgetWork\n  budgetType\n  defaultPeriodBudgetType\n  projectRevRecFirstDateYear\n  projectRevRecFirstDateMonth\n  projectRevRecFirstDateDay\n  projectRevRecLastDateYear\n  projectRevRecLastDateMonth\n  projectRevRecLastDateDay\n  fixedPriceLocks(first: 1000) {\n    edges {\n      node {\n        id\n        startDate\n        endDate\n        locked\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment TimeTotals_project on ProjectType {\n  id\n  projectFirstDateYear\n  projectFirstDateMonth\n  projectFirstDateDay\n  projectLastDateYear\n  projectLastDateMonth\n  projectLastDateDay\n  financialSourceSettings {\n    plannedHours\n    plannedRevenue\n    plannedCost\n    forecastHours\n    forecastRevenue\n    forecastCost\n    actualHours\n    actualRevenue\n    actualCost\n    id\n  }\n}\n\nfragment Totals_project on ProjectType {\n  id\n  budgetType\n  defaultPeriodBudgetType\n  projectFirstDateYear\n  projectFirstDateMonth\n  projectFirstDateDay\n  projectLastDateYear\n  projectLastDateMonth\n  projectLastDateDay\n  estimationUnit\n  financialSourceSettings {\n    plannedHours\n    plannedRevenue\n    plannedCost\n    forecastHours\n    forecastRevenue\n    forecastCost\n    actualHours\n    actualRevenue\n    actualCost\n    id\n  }\n  useFixedPriceForBaselineRevenue\n}\n\nfragment expenseRow_company on Company {\n  id\n  expenseCategories(first: 10000) {\n    edges {\n      node {\n        id\n        name\n        disabled\n      }\n    }\n  }\n}\n\nfragment expenseRow_project on ProjectType {\n  id\n  budgetType\n  companyProjectId\n}\n\nfragment expensesPage_company on Company {\n  ...expenseRow_company\n  id\n  currency\n  newXeroEnabled\n  sageIntacctConnectionEnabled\n  expenseCategories(first: 10000) {\n    edges {\n      node {\n        id\n        name\n        disabled\n      }\n    }\n  }\n}\n\nfragment expensesPage_project on ProjectType {\n  ...expenseRow_project\n  id\n  companyProjectId\n  billable\n  budgetType\n  stage {\n    __typename\n    id\n    name\n    profile\n  }\n  rateCard {\n    id\n    currency\n  }\n  expenseItems(first: 10000) {\n    edges {\n      node {\n        id\n        category {\n          id\n          name\n        }\n        phase {\n          id\n          name\n        }\n        name\n        approved\n        expenseYear\n        expenseMonth\n        expenseDay\n        billable\n        partOfFixedPrice\n        price\n        cost\n        quantity\n        planned\n        createdAt\n        invoiced\n        periodLocked\n        person {\n          id\n          fullName\n          profilePictureId\n          profilePictureDefaultId\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  fixedPriceLocks(first: 1000) {\n    edges {\n      node {\n        id\n        startDate\n        endDate\n        locked\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment ratesAndInternalCostPage_company on Company {\n  id\n  currency\n  roles(first: 10000) {\n    edges {\n      node {\n        id\n        name\n      }\n    }\n  }\n  dateEffectiveExchangeRates(first: 10000) {\n    edges {\n      node {\n        id\n        currency\n        rate\n        startDate\n      }\n    }\n  }\n  rateCards(first: 10000) {\n    edges {\n      ...RateCardDropdown_rateCards\n      node {\n        id\n        name\n        defaultRate\n        currency\n        parentRateCardId\n        rates(first: 10000) {\n          edges {\n            node {\n              id\n              rate\n              defaultRate\n              startDate\n              role {\n                id\n                name\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment ratesAndInternalCostPage_project on ProjectType {\n  id\n  budget\n  budgetType\n  taskCostCalculationType\n  unassignedTaskHourlyCost\n  projectPersons(first: 1000) {\n    edges {\n      node {\n        id\n        person {\n          id\n          isViewer\n          fullName\n          initials\n          profilePictureId\n          profilePictureDefaultId\n          active\n          permissions\n          costPeriods(first: 10000) {\n            edges {\n              node {\n                id\n                startDay\n                startMonth\n                startYear\n                cost\n              }\n            }\n          }\n        }\n        role {\n          id\n          name\n        }\n      }\n    }\n  }\n  rateCard {\n    id\n    currency\n    name\n    defaultRate\n    parentRateCardId\n    disabledRoles {\n      id\n    }\n    rates(first: 10000) {\n      edges {\n        node {\n          id\n          rate\n          defaultRate\n          startDate\n          role {\n            id\n            name\n          }\n        }\n      }\n    }\n  }\n  invoices(first: 100000000) {\n    edges {\n      node {\n        status\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "d17b5c66c5a6f4b9af9c916681c7973a";

export default node;
